import { BasicInfo } from "@/types/dto/common/basic-info";

const basicInfoFactory = (data: any = {}): BasicInfo => ({
  headerText: data?.headerText ?? "",
  copyText: data?.copyText ?? "",
  callToActionText: data?.callToActionText ?? "",
  callToActionUrl: data?.callToActionUrl ?? "",
  hubspotFormInfo: data?.hubspotFormInfo ?? undefined
});

export default basicInfoFactory;